import {
  MY_BOOKED_EXHIBITOR,
  FETCH_EXHIBITORS,
  SETEXHIBITORDETAILS,
  FETCH_EXHIBITOR_DETAILS,
  FETCH_EXB_CHAT_DETAILS,
  FETCH_APP_USER_NOTES,
  SHOW_ONLY_EXHIBITOR_DETAILS,
  FETCH_EXB_COUNTRY,
  FETCH_EXB_SECTORS,
  FETCH_EXB_CATEGORIES
} from '../actions';

export const myBookedExhibitor = (state = {}, action) => {
  switch (action.type) {
    case MY_BOOKED_EXHIBITOR:
      return action.payload;
    default:
      return state;
  }
};
export const allExhibitors_exb = (state = {}, action) => {
  switch (action.type) {
    case FETCH_EXHIBITORS:
      return action.payload;
    default:
      return state;
  }
};
export const exhibitor = (state = null, action) => {
  switch (action.type) {
    case SETEXHIBITORDETAILS:
      return action.payload;
    default:
      return state;
  }
};
export const exhibitorDetails = (state = null, action) => {
  switch (action.type) {
    case FETCH_EXHIBITOR_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const exbChatDetails = (state = null, action) => {
  switch (action.type) {
    case FETCH_EXB_CHAT_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const showOnlyExhibitorDetailsReducer = (state = false, action) => {
  switch (action.type) {
    case SHOW_ONLY_EXHIBITOR_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const exbCountryReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_EXB_COUNTRY:
      return action.payload;
    default:
      return state;
  }
};

export const exbSectorsReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_EXB_SECTORS:
      return action.payload;
    default:
      return state;
  }
};

export const exbCategoriesReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_EXB_CATEGORIES:
      return action.payload;
    default:
      return state;
  }
};
